import React from "react";
import { isSet,getCss, isArray } from "../../../../../../utils/commonUtils";
import Icons from "../../../../../../components/UI/Icons";

const returnResultData = (itm,formData)=>{
    let result = null;
    // When keyVal is an array, only decide Passed/Failed if any value is present; otherwise Not Started
    if(isArray(itm.keyVal)){
        const values = isSet(itm.keyVal, []).map((someKey)=> isSet(formData[someKey], undefined));
        const hasAnyValue = values.some((val)=> val !== undefined && val !== null && val !== '' && val !== '-');
        if(!hasAnyValue){
            result = 'Not Started';
        }else{
            result = values.some((val)=> val === 'Yes') ? 'Failed' : 'Passed';
        }
    }else{
        if (itm.type=='yesorno') {
            const val = isSet(formData[itm.keyVal], undefined);
            if (val === undefined || val === null || val === '' || val === '-') {
                result = 'Not Started';
            } else {
                result = val==='No' ? "Normal" : "Abnormal";
            }
        }
        else{
            const val = isSet(formData[itm.keyVal], undefined);
            result = (val === undefined || val === null || val === '' || val === '-' || val === 'undefined') ? 'Not Started' : val;
        }
        
    }
    return result;
}
const ResultSummary = (props) => {
    const {formData,results} = props;

    return (
        <div className="sh_cardBox h-auto sh_testdetailwidget m-2">
            <div className="sh_cardHeader">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-md text-dark font-weight-bold mb-0">
                        <span className="px-2">
                            <Icons type="newTestResultsIcon" />
                        </span>
                        Test Results
                    </h6>
                    {/* <button className="btn btn-xs text-xs text-info">View More</button> */}
                </div>
            </div>
            <div className="sh_cardBody px-2 py-1">
                <div className="row">
                    {results.map((item,itemIndex)=>{
                       const isFailed = isSet(item.data, []).some((itm) => {
                            let result = returnResultData(itm,formData);
                            return result === 'Failed' || result === 'Abnormal';
                          });
                        //   console.log('isFailed',item,isFailed);
                          const sortedItems = isSet(item.data, []).sort((a, b) => {
                            const resultA = returnResultData(a, formData);
                            const resultB = returnResultData(b, formData);
                            const order = {
                                'Abnormal': 1,
                                'Failed': 2,
                                'Passed': 3,
                                'Normal': 4,
                                'Not Started': 5,
                            };
                            const orderA = order[resultA] || Number.MAX_SAFE_INTEGER;
                            const orderB = order[resultB] || Number.MAX_SAFE_INTEGER;
                            // Sort based on the defined order
                            return orderA - orderB;
                        });
                        return(
                            <div className="col-md-12 mb-4" key={itemIndex}>
                                {/* Section Title */}
                                <div className="mb-2 mt-2">
                                    {(isFailed === true ?
                                        <h6 className="text-md text-dark font-weight-bold mb-0 opacity-70">{item.normalMsg}</h6> :
                                        <h6 className="text-md text-dark font-weight-bold mb-0 opacity-70">{item.abnormalMsg}</h6>
                                    )}
                                </div>
                                {/* HEADER ROW: Section | Results */}
                                <div className="row  py-2 rounded-top"style={{ backgroundColor: "#F0F3FD" }}>
                                    <div className="col-7 pl-3">
                                        <span className="text-xs font-weight-bold text-uppercase text-dark">SECTION</span>
                                    </div>
                                    <div className="col-5 pl-1">
                                        <span className="text-xs font-weight-bold text-uppercase text-dark">RESULTS</span>
                                    </div>
                                </div>

                                {/* Items List */}
                                <div className="form-group mb-1">
                                    {sortedItems.map((itm, itmIndex) => {
                                        let result = returnResultData(itm, formData);
                                        const displayResult =
                                            result === "Failed" ||
                                                result === "Abnormal"
                                                ? "Abnormal"
                                                : result === "Normal" ||
                                                    result === "Passed"
                                                    ? "Normal"
                                                    : "Not Started";

                                        // Apply specific CSS classes based on displayResult
                                        let badgeClasses = "badge mr-2 ";
                                        if (displayResult === "Abnormal") {
                                            badgeClasses += "sh_dashbg-red sh_dashtext-red font-weight-bold";
                                        } else if (displayResult === "Normal") {
                                            badgeClasses += "sh_dashbg-green sh_dashtext-green font-weight-bold";
                                        } else if (displayResult === "Not Started") {
                                            badgeClasses += "sh_dashbg-grey sh_dashtext-grey font-weight-bold";
                                        }

                                        let otherArributes = {...getCss(itm.keyVal, displayResult, 'LIGHT') };
                                        
                                        // Retrieve actual value for display (e.g. 139/70)
                                        let actualVal = isSet(formData[itm.keyVal], '');
                                        // Don't show actual value if it's just the Yes/No logic strings, otherwise show it
                                        const showActualValue = actualVal && actualVal !== 'Yes' && actualVal !== 'No' && actualVal !== result;

                                        return (
                                            <div className="row align-items-center mb-0 py-2" key={itmIndex} style={{ backgroundColor: itmIndex % 2 !== 0 ? "#F0F3FD" : "#ffffff" }}>
                                                
                                                {/* Left Column: Label */}
                                                <div className="col-7 pl-3">
                                                    <h6 className="text-sm text-dark mb-0 font-weight-normal" title={itm.label}>{itm.label}</h6>
                                                </div>

                                                {/* Right Column: Badge + Value */}
                                                <div className="col-5 pl-1 d-flex align-items-center">
                                                    <span className={badgeClasses}>
                                                        {displayResult}
                                                    </span>
                                                    {/* Display the raw value (like 139/70) if it exists */}
                                                    {/* {showActualValue && (
                                                        <span className="text-sm text-dark font-weight-bold">
                                                            {actualVal}
                                                        </span>
                                                    )} */}
                                                </div>
                                           
                                            </div>
                                        ) 
                                    })}
                                   
                                    {/* <h6 className="font-weight-bold text-sm text-truncate" title={item.value}>{isSet(formData[item.keyVal],'-')}</h6> */}
                                </div>
                               
                            </div>
                        )
                    })}
                    
                    
                </div>
            </div>
        </div>
    )
}

export default ResultSummary;
